/**
 * youtube-embed.js — <youtube-embed>, a click-to-play YouTube block.
 *
 * snippets/video-embeds.liquid renders a link to the video. Without JS the link opens YouTube. With
 * JS, pressing play swaps the link for the player from youtube-nocookie.com, so nothing is requested
 * from YouTube until the visitor asks for it. The iframe is marked data-cookieconsent="ignore": the
 * visitor's click is the choice, and the consent manager would otherwise hide it again.
 */
(() => {
  if (customElements.get('youtube-embed')) return;

  const ID = /^[\w-]{6,20}$/;

  class YoutubeEmbed extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('.youtube-embed__play');
      if (!this.link) return;
      this.onClick = (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.button) return;
        event.preventDefault();
        this.load();
      };
      this.link.addEventListener('click', this.onClick);
    }

    load() {
      const id = this.dataset.id || '';
      if (!ID.test(id)) return;
      const frame = document.createElement('iframe');
      frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
      frame.title = this.dataset.title || '';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture';
      frame.allowFullscreen = true;
      frame.setAttribute('data-cookieconsent', 'ignore');
      this.replaceChildren(frame);
      frame.focus();
    }

    disconnectedCallback() {
      if (this.link) this.link.removeEventListener('click', this.onClick);
    }
  }

  customElements.define('youtube-embed', YoutubeEmbed);
})();
